import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import UserLogsPage from './UserLogsPage'
import FilesPage from './file-area/Filespage'
import SharedFilesPage from './shared-files/SharedFilesPage'
import MagicLinksPage from './magic-links/MagicLinksPage'
import UsersListPage from './users-list/UsersListPage'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'

const UsersPage: React.FC = () => {
  const intl = useIntl()
  const role = useSelector<RootState, string | null | undefined>(
    ({ auth }) => auth.role,
    shallowEqual
  )
  const roles = role?.toLowerCase() ?? ''
  // const devicesBreadcrumbs: Array<PageLink> = [
  //   {
  //     title: intl.formatMessage({ id: 'MENU.USERS' }),
  //     path: '/users',
  //     isSeparator: false,
  //     isActive: false,
  //   },
  // ]

  return (
    <>
      <Routes>
        <Route
          path='/logs'
          element={
            <>
              <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.USER_LOGS' })}</PageTitle>
              <UserLogsPage />
            </>
          }
        />

        <Route
          path='/files'
          element={
            <>
              <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.FILE_AREA' })}</PageTitle>
              <FilesPage />
            </>
          }
        />
        <Route
          path='/shared-files'
          element={
            <>
              <PageTitle breadcrumbs={[]}>
                {intl.formatMessage({ id: 'MENU.SHARED_FILES' })}
              </PageTitle>
              <SharedFilesPage />
            </>
          }
        />
        <Route
          path='/magic-links'
          element={
            <>
              <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.MAGIC_LINKS' })}</PageTitle>
              <MagicLinksPage />
            </>
          }
        />
        {roles === 'admin' && (
          <Route
            path='/list'
            element={
              <>
                <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.USERS' })}</PageTitle>
                <UsersListPage />
              </>
            }
          />
        )}
      </Routes>
    </>
  )
}

export default UsersPage
